import {ApiResponse} from '@legit-health/backend-client';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';
import {PatientApiResponse} from './types';

export const PATIENT_PATCHED_EVENT = 'patient.patched';

export interface PatientPatchedEvent extends DomainEvent {
  response: ApiResponse<PatientApiResponse>;
}

export function createPatientPatchedEvent(
  response: ApiResponse<PatientApiResponse>
): PatientPatchedEvent {
  return Object.freeze({
    name: PATIENT_PATCHED_EVENT,
    response
  });
}
